export default function Titulo(){
    return(
        <h2 className="titulo">Trends</h2>
    )
}